import React from 'react';
import { IoIosArrowBack } from 'react-icons/io';
import TouchableOpacity from '../components/TouchableOpacity';
import history from '../history';

interface LoyaltyPaymentScreenProps {
  readonly children: React.ReactNode;
}

const LoyaltyPaymentScreen = ({ children }: LoyaltyPaymentScreenProps) => {
  return (
    <div style={styles.container}>
      <TouchableOpacity style={styles.backButton} onClick={() => history.goBack()}>
        <IoIosArrowBack style={styles.backIcon} />
      </TouchableOpacity>
      {children}
    </div>
  );
};

const styles: Styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  backButton: {
    alignSelf: 'flex-start',
    marginBottom: 8,
  },
  backIcon: {
    fontSize: 35,
    position: 'sticky',
    top: 40,
    alignSelf: 'flex-start',
    translate: -50,
  },
};

export default LoyaltyPaymentScreen;
